import type { FC } from 'react';

import { Box, Container } from '@mui/material';

export const AccountActivationHeader: FC = () => {
  return (
    <Box
      className="group hidden h-12 w-full flex-nowrap items-center justify-center text-center text-white sm:flex"
      sx={{
        backgroundImage: 'linear-gradient(90deg, #224185 0%, #254a9e 15%, #203565 50%, #2855bb 70%, #223c79 100%)',
      }}
    >
      <Container disableGutters className="relative h-full px-4" maxWidth="xl">
        <div className="flex h-full w-full items-center justify-center">
          <div className="flex flex-col items-center">
            <div className="mx-auto w-fit font-semibold opacity-95 group-hover:opacity-100">
              Account activation in progress
            </div>
            <div className="mx-auto w-fit text-sm opacity-90 group-hover:opacity-100">
              We&apos;re reviewing your business details. This usually takes 1 business day.
            </div>
          </div>
        </div>
      </Container>
    </Box>
  );
};
